import Udesk from 'Udesk';
import React, { FC, memo, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { Tabs } from 'udesk-ui';
import LayoutMenu from 'Component/common/layout-menu';
import Page from 'Component/common/udesk-qa-page-layout';
import SubRoutes from 'udesk-react/src/components/sub-routes';

interface TemplateProps {
    sdkOptions?: any;
    route?: any;
    location?: any;
    navLists?: any[];
    menuTitle?: string;
    hideSider?: boolean;
    match?: any;
    isTabs?: boolean;
    routes?: any;
    history?: any;
    onBack?: () => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        sdkOptions,
        route,
        location,
        navLists = [],
        menuTitle,
        hideSider,
        match,
        isTabs,
        onBack,
    } = props;

    const isRedirect = (currentPath: any, toPath: string) => {
        let fullCurrentPath = Udesk.ui.routing.getRoutePath({
            routeName: currentPath.name,
            pathParams: props.match.params,
        });
        if (fullCurrentPath === toPath) {
            return true;
        }
        return false;
    };

    const _navLists = navLists.filter((nav) => !nav.isHidden);

    const [activeKey, setActiveKey] = useState<string>('');

    useEffect(() => {
        const currentPath = _navLists.find(
            (item) => props.history.location.pathname.indexOf(item.key) >= 0
        );

        if (currentPath) {
            setActiveKey(currentPath.key as any);
        }
    }, [_navLists, props.history.location]);

    const onAddTypeChange = (activeKey) => {
        setActiveKey(activeKey);
        const tab: any = _navLists.find((t) => t.key === activeKey) ?? {};
        const routeOptions = {
            history: props.history,
            routeName: tab.pathName,
            pathParams: tab.pathParams,
        };
        Udesk.ui.routing.transitionTo(routeOptions);
    };

    if (sdkOptions?.props.landingPath != null && isRedirect(route, location.pathname)) {
        let toPath = location.pathname + sdkOptions.props.landingPath;
        return <Redirect to={toPath} sdkOptions={sdkOptions} />;
    } else if (_navLists.length > 0 && isRedirect(route, location.pathname)) {
        let toPath = null;
        if (_navLists[0].pathName) {
            toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: _navLists[0].pathName,
                pathParams: match.params,
            });
        } else {
            toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
                routeName: _navLists[0].children[0].pathName,
                pathParams: match.params,
            });
        }

        return <Redirect to={toPath} sdkOptions={sdkOptions} />;
    } else {
        return !isTabs ? (
            <LayoutMenu
                {...props}
                navLists={_navLists}
                menuTitle={menuTitle}
                hideSider={hideSider}
            />
        ) : (
            <Page
                pageBodyClassName="xxx-page-index"
                title={menuTitle}
                padding={true}
                onBack={onBack}
            >
                <Tabs activeKey={activeKey} onChange={onAddTypeChange}>
                    {props.routes.map((item, i) => {
                        const tab: any = _navLists.find((t) => t.pathName === item.name);

                        if (!tab || tab.hidden) {
                            return null;
                        } else {
                            return (
                                <Tabs.TabPane tab={tab.text} key={tab.key}>
                                    <SubRoutes key={i} route={item} />
                                </Tabs.TabPane>
                            );
                        }
                    })}
                </Tabs>
            </Page>
        );
    }
});

export default Template;
